import SectionTitle from './section-title';
export default SectionTitle;
